export interface UserPayload {
    id: number
    name: string
    last_name: string
    email: string
}

export class User {

    id: number
    name: string
    lastName: string
    email: string

    constructor(data: UserPayload) {
        this.id = data.id
        this.name = data.name
        this.lastName = data.last_name
        this.email = data.email
    }

    public get fullName(): string {
        return this.name + ' ' + this.lastName
    }

    fill(data: UserPayload): this {
        this.id = data.id
        this.name = data.name
        this.lastName = data.last_name
        this.email = data.email
        return this
    }

    payload(): UserPayload {
        return {
            id: this.id,
            name: this.name,
            last_name: this.lastName,
            email: this.email
        }
    }
}